import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOverlapResponse {
  /**
   * Beginning date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;
}
